import "inputmask"
$(document).ready(function() {
    $('input[type="checkbox"]').on('change', function () {
        $(this).parents('.js-checkbox-label').toggleClass('checked');
    })

    $('.js-user-show').on('click', function(e) {
        e.preventDefault();

        $('.dental-menu__menu').addClass('show');
        $('.dental-menu__menu').after('<div class="modal-backdrop show menu"></div>')
    })

    $('body').on('click', '.modal-backdrop.show.menu', function () {
        $('.dental-menu__menu').removeClass('show');
        $('.modal-backdrop.show.menu').remove();
    })

    Inputmask("+7 (999) 999-99-99").mask(".phone-mask");

    // Bootstrap tooltips initialization (supports BS4 and BS5 attributes)
    (function () {
        const selector = '[data-toggle="tooltip"], [data-bs-toggle="tooltip"]';

        window.initTooltips = function (root) {
            if (!($.fn && $.fn.tooltip)) return;

            const $root = root ? $(root) : $(document);
            // Include root if it matches selector
            let $els = $root.find(selector);
            if ($root.is && $root.is(selector)) {
                $els = $els.add($root);
            }

            // Filter out already initialized tooltips (BS4/BS5)
            $els = $els.filter(function () {
                // Bootstrap 5 native API
                if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip && bootstrap.Tooltip.getInstance) {
                    return !bootstrap.Tooltip.getInstance(this);
                }
                // Bootstrap 4 jQuery plugin data key
                return !$(this).data('bs.tooltip');
            });

            if ($els.length) {
                $els.tooltip({
                    container: 'body',
                    boundary: 'viewport',
                    html: true
                });
            }
        };

        // Initial pass
        try { window.initTooltips(); } catch (e) {}

        // Re-init on AJAX complete
        $(document).on('ajaxComplete', function () {
            try { window.initTooltips(); } catch (e) {}
        });

        // Re-init when modals are shown (content often injected)
        $(document).on('shown.bs.modal', function (e) {
            try { window.initTooltips(e.target); } catch (e) {}
        });

        // Re-init on DOM mutations (dynamic content)
        try {
            const observer = new MutationObserver(function (mutations) {
                for (const m of mutations) {
                    for (const node of m.addedNodes) {
                        if (node.nodeType === 1) {
                            window.initTooltips(node);
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        } catch (e) {}
    })();

    const masks = {
        "+7": "+7 (999) 999-99-99", // Россия
        "+375": "+375 (99) 999-99-99", // Беларусь
    };

    // Функция для определения маски по введенному коду страны
    function getMaskByPhoneNumber(phoneNumber) {
        // Проверяем начало номера на соответствие кодам стран
        for (const code in masks) {
            if (phoneNumber.startsWith(code)) {
                return masks[code];
            }
        }
        return "+999 999 999 999"; // Общая маска, если код страны не распознан
    }

    // Убираем код страны из введённых цифр, потому что он уже задан литералом в маске.
    function getPhoneNumberForMask(phoneNumber, mask) {
        for (const code in masks) {
            if (masks[code] === mask && phoneNumber.startsWith(code.substring(1))) {
                return phoneNumber.substring(code.length - 1);
            }
        }

        return phoneNumber;
    }

    // На странице входа сохраняем выбор маски по коду страны без переустановки
    // Inputmask во время набора: старый Chrome Android при этом теряет курсор.
    document.querySelectorAll('.phone-mask-login').forEach(input => {
        let composing = false;

        function formatPhone() {
            const rawValue = input.value;
            const caret = input.selectionStart == null ? rawValue.length : input.selectionStart;
            const digitsBeforeCaret = rawValue.slice(0, caret).replace(/\D/g, '').length;
            const digits = rawValue.replace(/\D/g, '');

            if (!digits) {
                input.value = '';
                return;
            }

            const mask = getMaskByPhoneNumber('+' + digits);
            const number = getPhoneNumberForMask(digits, mask);
            let digitIndex = 0;
            const formatted = mask.replace(/9/g, () => number[digitIndex++] || '_');

            if (rawValue === formatted) return;

            input.value = formatted;
            if (document.activeElement !== input || typeof input.setSelectionRange !== 'function') return;

            let formattedDigitCount = 0;
            let newCaret = 0;
            while (newCaret < formatted.length && formattedDigitCount < digitsBeforeCaret) {
                if (/\d/.test(formatted[newCaret])) formattedDigitCount++;
                newCaret++;
            }
            while (newCaret < formatted.length && !/[\d_]/.test(formatted[newCaret])) newCaret++;
            input.setSelectionRange(newCaret, newCaret);
        }

        input.addEventListener('compositionstart', () => { composing = true; });
        input.addEventListener('compositionend', () => {
            composing = false;
            formatPhone();
        });
        input.addEventListener('input', () => {
            if (!composing) formatPhone();
        });
        formatPhone();
    });

    // Применяем маску ко всем элементам с классом .phone-mask-multi
    document.querySelectorAll('.phone-mask-multi').forEach(input => {

        let maskInstance = null;

        // Функция для обновления маски
        function updateMask() {
            const currentValue = input.value.replace(/\D/g, ''); // Убираем все нецифровые символы
            const newMask = getMaskByPhoneNumber("+" + currentValue);

            // Если маска изменилась, обновляем её
            if (!maskInstance || maskInstance.opts.mask !== newMask) {
                if (maskInstance) {
                    maskInstance.remove(); // Удаляем старую маску
                }

                // Сохраняем уже введённые цифры при переключении маски.
                // Код страны не переносим: он является фиксированной частью новой маски.
                input.value = getPhoneNumberForMask(currentValue, newMask);
                maskInstance = Inputmask({
                    mask: newMask,
                    placeholder: "_",
                    showMaskOnHover: false,
                    showMaskOnFocus: true,
                    greedy: false,
                    clearIncomplete: false,
                    onBeforeMask: function (value) {
                        return value.replace(/\D/g, '');
                    },
                    onBeforePaste: function (pastedValue) {
                        return pastedValue.replace(/\D/g, '');
                    }
                }).mask(input);
            }
        }

        // Отслеживаем изменения значения поля
        input.addEventListener('input', function () {
            updateMask();
        });

        // Обработка удаления символов
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Backspace' || event.key === 'Delete') {
                // Если поле пустое или содержит только "+", сбрасываем маску
                const currentValue = input.value.replace(/\D/g, '');
                if (currentValue.length <= 1) {
                    if (maskInstance) {
                        maskInstance.remove(); // Удаляем старую маску
                    }
                    maskInstance = Inputmask({
                        mask: "+999 999 999 999",
                        placeholder: "_",
                        showMaskOnHover: false,
                        showMaskOnFocus: true,
                        greedy: false,
                        clearIncomplete: false,
                        onBeforeMask: function (value) {
                            return value.replace(/\D/g, '');
                        }
                    }).mask(input);
                }
            }
        });

        // Инициализация маски при загрузке
        updateMask();
    });

    // Глобальный keep-alive: продлеваем сессию и CSRF-токен без действий пользователя
    (function startGlobalKeepAlive() {
        if (window.__keepAliveTimer) {
            return
        }
        const ping = () => {
            fetch(window.location.pathname, {
                method: 'HEAD',
                credentials: 'same-origin',
            }).catch(() => {
                // Ошибки пинга не критичны, запрос нужен только для продления сессии
            })
        }

        ping()
        window.__keepAliveTimer = setInterval(ping, 1000 * 60 * 5) // раз в 5 минут
    })();
});
